import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
};

const pdfPrinter = () => {
    const store = useStore();
    const { commaFormat } = figureFormatter();
    const { getHeader, getFooter } = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, saleOrderData, startDate = '', endDate = '', params = {}) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(saleOrderData, startDate, endDate, params),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'Sale Order Register Invoice (' + startDate + ' to ' + endDate + ')',
            }
        }

        pushIntoTable(doc, saleOrderData)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (saleOrderData, startDate, endDate, params) => {
        return [
            {
                text:  'Sale Order Register (' + startDate + ' to ' + endDate + ')',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                margin: [0, 10, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            {
                                text: `${params.contact_profile ? 'Party: ' +  getTopHeadData(saleOrderData.data, 'contact_name') : ''}`,
                                color: 'black',
                                bold: true,
                            },
                        ]

                    }
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: [ 'auto', '*', '*', '*', '*', '*' ],
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const pushIntoTable = (doc, saleOrderData) => {
        const tableItems = saleOrderData.data;
        const tableHeader = getTableHeader();
        doc.content[2].table.body.push(tableHeader);

        tableItems.forEach((item, i) => {
            const rowData = getRowData(item, i);
            return doc.content[2].table.body.push(rowData);
        });

        const getLastRow = getTotal(saleOrderData.total)
        doc.content[2].table.body.push(getLastRow);
    }

    const getTopHeadData = (items, field) => {
        if (!items || items.length === 0) return '';

        const firstItem = items[0];
        if (!firstItem.hasOwnProperty(field) || firstItem[field] === null || firstItem[field] === undefined) {
            return '';
        }

        return firstItem[field]
            .toString()
            .replace(/_/g, ' ')
            .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    }

    const getTableHeader = () => {
        const tableHeader = [
            {text: 'SL#'},
            {text: 'Date'},
            {text: 'Order Number'},
            {text: 'Total Amount', alignment: 'right'},
            {text: 'Discount Amount', alignment: 'right'},
            {text: 'Net Amount', alignment: 'right'},
        ]

        return tableHeader
    }
    const getRowData = (item, i) => {
        const tableRow = [
            {text: i+1},
            {text: item.date},
            {text: item.bill_number},
            {text: commaFormat(item.total_amount), alignment: 'right'},
            {text: item.discount_amount ? parseFloat(item.discount_amount).toFixed(2) : 0, alignment: 'right'},
            {text: (parseFloat(item.total_amount) - parseFloat(item.discount_amount)).toFixed(2), alignment: 'right'}
        ]

        return tableRow
    }

    const getTotal = (totalValue) => {

        const lastRow = [
            {
                text: 'Total',
                alignment: 'right',
                colSpan: 3
            },

            '','',

            {
                text: totalValue.total_total_amount,
                alignment: 'right'
            },

            {
                text: totalValue.total_discount_amount,
                alignment: 'right'
            },

            {
                text: totalValue.total_net_amount,
                alignment: 'right'
            }
        ]

        return lastRow
    }

    return {
        exportToPDF
    }

}

export default pdfPrinter;